<template>
    <svg width="20" height="5" viewBox="0 0 20 5" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="18" cy="2.76" r="2" transform="rotate(90 18 2.76)" fill="#545E61" />
        <circle cx="10" cy="2.76" r="2" transform="rotate(90 10 2.76)" fill="#545E61" />
        <circle cx="2" cy="2.76" r="2" transform="rotate(90 2 2.76)" fill="#545E61" />
    </svg>
</template>
